import axios from 'axios';
import { createAuthHeaders } from '../api-client';

const API_URL = import.meta.env.VITE_API_URL;

export interface CreditBalanceResponse {
  balance: number;
}

export type PlanType = 'free' | 'standard' | 'pro' | 'enterprise';

export interface CreditDetailsResponse {
  balance: number;                    // Total (subscription + top-up)
  subscriptionBalance: number;        // Subscription credits (resets on billing cycle)
  topupBalance: number;               // Top-up credits (never resets)
  allocated: number;
  totalUsed: number;
  currentCycleUsed: number;
  lastResetAt: string | null;
  nextResetAt: string | null;
  planType: PlanType;
}

export const creditsApi = {
  /**
   * Get current credit balance for workspace
   */
  async getBalance(token: string): Promise<number> {
    const response = await axios.get<CreditBalanceResponse>(
      `${API_URL}/api/credits/balance`,
      { headers: createAuthHeaders(token) },
    );
    return response.data.balance;
  },

  /**
   * Get full credit details for workspace
   */
  async getDetails(token: string): Promise<CreditDetailsResponse> {
    const response = await axios.get<CreditDetailsResponse>(
      `${API_URL}/api/credits/details`,
      { headers: createAuthHeaders(token) },
    );
    return response.data;
  },
};
